var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { createEmit, createSelect } from '@banking/ui/lib/workflow-ember/decorators';
import Service, { inject as service } from '@ember/service';
import unifiedActivity, { INITIAL_STATE } from '@banking/ui/workflows/unified-activity/unified-activity';
import { updateLogger } from '@banking/ui/lib/workflow/update-logger';
import { tracked } from '@glimmer/tracking';
import { fromSFSTransaction } from '@banking/ui/utils/activity';
import connect from '@banking/ui/lib/workflow-ember/connect';
import { detailsFromSFSTransaction } from '@banking/ui/utils/activity/from-sfs-transaction';
import { momentFromDateTimeWithZone, convertDateToYearMonthDay } from '@banking/ui/utils/datetime-converter';
const SERVICE_REGISTRY_KEY = 'savings-reporter';
const BATCH_SIZE = 100;
let SavingsReporter = (_class = class SavingsReporter extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "sentry", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "logEvents", _descriptor3, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor4, this);
    _initializerDefineProperty(this, "sfsTransferApi", _descriptor5, this);
    _initializerDefineProperty(this, "dataApi", _descriptor6, this);
    _initializerDefineProperty(this, "features", _descriptor7, this);
    _initializerDefineProperty(this, "state", _descriptor8, this);
    _defineProperty(this, "states", void 0);
    _defineProperty(this, "emit", void 0);
    _defineProperty(this, "updates", void 0);
    const sfsTransferApi = this.sfsTransferApi;
    const intl = this.intl;
    const features = this.features;
    const {
      emit,
      states,
      updates
    } = unifiedActivity({
      async getActivities(query, category, batchRequest) {
        const owner = query.activityOwners[0];
        if (owner.type !== 'account') {
          throw new Error('cannot get activities for non-account id');
        }
        const currentPaginationToken = batchRequest ? Number(batchRequest.batchToken) : undefined;
        const pageSize = batchRequest ? batchRequest.batchSize : BATCH_SIZE;
        const convertStartAtToDate = query.startAt ? momentFromDateTimeWithZone(query.startAt).toDate() : undefined;
        const beginDate = convertStartAtToDate ? convertDateToYearMonthDay(convertStartAtToDate) : undefined;

        // If single day selected (valid startAt, no endAt), then set the endAt to the startAt
        const convertEndAtToDate = query.endAt ? momentFromDateTimeWithZone(query.endAt).toDate() : convertStartAtToDate;
        const endDate = convertEndAtToDate ? convertDateToYearMonthDay(convertEndAtToDate) : undefined;
        try {
          const result = await sfsTransferApi.listTransactions(owner.accountId, currentPaginationToken, pageSize, beginDate, endDate);
          const {
            transactions
          } = result;
          let {
            pageNumber
          } = result;
          const allActivities = transactions.map(transaction => fromSFSTransaction(transaction, intl, features));
          let activities;
          switch (category) {
            case 'completed':
              activities = allActivities.filter(activity => !activity.isPending);
              break;
            case 'pending':
              activities = allActivities.filter(activity => activity.isPending);
              break;
          }
          // If we are looking for pending activities and the filtered list of
          // activities is smaller than the unfiltered list then we also got
          // some completed activities in this request. Therefore set page number
          // to null since we are now done with pending activities.
          //
          // We must deal with this edgecase since UA queries pending and completed
          // activities separately.
          if (category === 'pending' && activities.length < allActivities.length) {
            pageNumber = null;
          }
          return {
            activities,
            paginationToken: pageNumber ? pageNumber.toString() : null
          };
        } catch (error) {
          return new Error(`failed to fetch transactions: ${error}`);
        }
      },
      async getActivityDetails(id, query) {
        const owner = query.activityOwners[0];
        if (owner.type !== 'account') {
          throw new Error('cannot get activities for non-account id');
        }
        const details = await sfsTransferApi.retrieveTransactionDetails(id, owner.accountId);
        if (!details?.transaction) {
          return new Error('cannot parse details response');
        }
        const formattedDetail = detailsFromSFSTransaction(details.transaction, intl, features, details);
        return formattedDetail;
      },
      cancelPrintableCheck() {
        // Savings does not use this function.
        throw new Error('unimplemented');
      },
      dataApi: this.dataApi,
      dismissPrintableCheckBlade() {
        // Savings does not use this function.
        throw new Error('unimplemented');
      },
      downloadCheck() {
        // Savings does not use this function.
        throw new Error('unimplemented');
      },
      getBootstrapPrintableCheckManagement() {
        // Savings does not use this function.
        throw new Error('unimplemented');
      },
      listCategories() {
        // Savings does not use this function.
        throw new Error('unimplemented');
      },
      logEvents: this.logEvents,
      marketToasts: this.marketToasts,
      recognizeTransaction() {
        // Savings does not use this function.
        throw new Error('unimplemented');
      },
      retrieveTransactionAuth() {
        // Savings does not use this function.
        throw new Error('unimplemented');
      },
      printCheck() {
        // Savings does not use this function.
        throw new Error('unimplemented');
      },
      sentry: this.sentry,
      updateCategory() {
        // Savings does not use this function.
        throw new Error('unimplemented');
      },
      translate: key => this.intl.t(key)
    }, {
      config: {
        requireExportLink: this.features.isEnabled('sfscore/batch_automated_transactions') ?? false,
        enablePostedBalance: false,
        typeCategories: [],
        activityPageSize: BATCH_SIZE
      }
    });
    this.emit = emit;
    this.states = states;
    this.updates = updates;
    states.subscribe(state => {
      this.state = state;
    });
    updates.subscribe(updateLogger('UA Savings'));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sfsTransferApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "state", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return INITIAL_STATE;
  }
}), _class);
export { SavingsReporter as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.
export const select = createSelect(SERVICE_REGISTRY_KEY);
export const emit = createEmit(SERVICE_REGISTRY_KEY);
export const workflowComponent = connect(SERVICE_REGISTRY_KEY);